var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _includesInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/includes");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/instance/includes", "@babel/runtime-corejs3/core-js/date/now"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/instance/includes"), require("@babel/runtime-corejs3/core-js/date/now"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, _includesInstanceProperty2(global), global.now);
    global.index = mod.exports;
  }
})(this, function (_exports, _includes, _now) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = _default;
  _includes = _interopRequireDefault(_includes);
  _now = _interopRequireDefault(_now);

  // import { BEHAVIOR_TYPES_MAP } from '../constant'

  /**
   * @param {string} type
   * @param {!Object} data
   * @return {undefined}
   */
  var dispatchEvent = function dispatchEvent(type, data) {
    var evt;
    var document = window.document;

    if (window.CustomEvent) {
      evt = new CustomEvent(type, {
        detail: data
      });
    } else {
      (evt = document.createEvent('HTMLEvents')).initEvent(type, false, true);
      evt.detail = data;
    }

    window.dispatchEvent(evt);
  };
  /**
   * 格式化url，去除协议以及查询参数
   * @param {string} data
   * @return {?}
   */


  var removeQuery = function removeQuery(data) {
    return data && typeof data === 'string' ? data.replace(/\?.*$/, '') : '';
  };
  /**
   * 格式化url，去除协议以及查询参数
   * @param {string} data
   * @return {?}
   */


  var urlFormat = function urlFormat(data) {
    return data && typeof data === 'string' ? removeQuery(data.replace(/^(https?:)?\/\//, '')) : '';
  };
  /**
   * @param {!Object} target
   * @param {string} type
   * @param {?} callback
   * @param {?} isPk
   * @return {?}
   */


  var onListen = function onListen(target, type, callback, isPk) {
    return target.addEventListener ? target.addEventListener(type, function eventHandler(e) {
      if (isPk) {
        target.removeEventListener(type, eventHandler, false);
      }

      callback.call(this, e);
    }, false) : target.attachEvent && target.attachEvent('on' + type, function eventHandler(e) {
      if (isPk) {
        target.detachEvent('on' + type, eventHandler);
      }

      callback.call(this, e);
    });
  };
  /**
   * @param {!Object} elem
   * @param {string} event
   * @param {?} handler
   * @return {?}
   */


  var offListen = function offListen(elem, event, handler) {
    return handler ? elem.removeEventListener ? elem.removeEventListener(event, handler) : elem.detachEvent && elem.detachEvent(event, handler) : this;
  };
  /**
   * @param {string} query
   * @return {?}
   */


  var format = function format(query) {
    var dsn;
    return (query ? (dsn = query.replace(/^#\/?/, '')) && typeof dsn === 'string' ? urlFormat(dsn) : '' : '') || '[index]';
  };
  /**
   * 统计PV
   * @export
   */


  function _default() {
    var self = this;
    var history = window.history || {};
    var lastURL;
    var start; // 对上报做限制
    // 如果两次上报时间过短，则只上报一次
    // 如果两次上报的页面地址一致，则只上报一次

    var reportCheck = function reportCheck(url, load) {
      var now = (0, _now.default)();
      if (start && now - start < 1000) return false;
      if (url === lastURL) return false;
      start = now; // enqueue 此处入队，记录用户行为
      // self.behaviorQueue.enqueue({
      //   type: load ? BEHAVIOR_TYPES_MAP.BEHAVIOR_TYPES_LOAD : BEHAVIOR_TYPES_MAP.BEHAVIOR_TYPES_NAV,
      //   timestamp: Date.now(),
      //   lastPage: lastURL,
      //   page: url
      // })

      lastURL = url;
      return true;
    };

    var initListener = function initListener() {
      var onHashChange;
      var onHistoryChange;
      var onPopstateChange; // onload不用校验时间差

      var onLoad = function onLoad() {
        var curURL = removeQuery(window.location.href);
        reportCheck(curURL, true) && self.product(10003, {
          url: curURL
        });
      }; // 非单页应用 | 页面刷新 | 页面首次加载
      // onListen(window, 'load', onLoad, true)


      onListen(window, 'DOMContentLoaded', onLoad, true); // 单页应用

      if (self.spa) {
        // hash模式
        onHashChange = function onHashChange() {
          var curURL = removeQuery(window.location.href);

          if (reportCheck(curURL) && format(location.hash)) {
            self.product(10003, {
              url: curURL
            });
          }
        }; // history模式


        onHistoryChange = function onHistoryChange(event) {
          var curURL = removeQuery(window.location.href);

          if (reportCheck(curURL) && format(event.detail)) {
            self.product(10003, {
              url: curURL
            });
          }
        }; // popstate


        onPopstateChange = function onPopstateChange(event) {
          var curURL = removeQuery(window.location.href);

          if (reportCheck(curURL)) {
            self.product(10003, {
              url: curURL
            });
          }
        };

        onListen(window, 'hashchange', onHashChange);
        onListen(window, 'historystatechange', onHistoryChange); // 监听浏览器返回

        onListen(window, 'popstate', onPopstateChange);
      } // 浏览器关闭 || 刷新触发


      onListen(window, 'beforeunload', function () {
        offListen(window, 'load', onLoad);
        offListen(window, 'hashchange', onHashChange);
        offListen(window, 'historystatechange', onHistoryChange);
        offListen(window, 'popstate', onPopstateChange);
        onLoad = onHashChange = onHistoryChange = onPopstateChange = null;
      });
    };

    initListener();
    /**
     * @param {string} type
     * @return {undefined}
     */

    var expect = function expect(type) {
      var handler = history[type];

      if (typeof handler === 'function') {
        history[type] = function (stateObj, title, url) {
          var href = location.href;
          var host = location.host;
          var res = handler.call(history, stateObj, title, url);
          if (!url || typeof url !== 'string') return res;
          if (url === href) return res;

          if (!(0, _includes.default)(url).call(url, host)) {
            url = host + url;
          }

          try {
            var parameters = href.split('#');
            var node = url.split('#'); // 去协议去参数

            var nodeName = urlFormat(parameters[0]);
            var input = urlFormat(node[0]); // 获取参数

            var p = parameters[1] && parameters[1].replace(/^\/?(.*)/, '$1');

            var _type = node[1] && node[1].replace(/^\/?(.*)/, '$1'); // 先对比host & path是否完全相同


            if (nodeName !== input) {
              dispatchEvent('historystatechange', input);
            } else {
              // 再对比参数
              if (p !== _type) {
                dispatchEvent('historystatechange', _type);
              }
            }
          } catch (t) {}

          return res;
        };

        history[type].toString = type + '() { [native code] }';
      }
    };

    expect('pushState');
    expect('replaceState');
  }
});